const validateTel = value => {
  const emailRegex = /^\+[0-9\-\s]+/;
  return emailRegex.test(value);
};

export default validateTel;
